import React, { useState, useEffect } from 'react'
import { Table, Tag } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { GET_TEAM_MEMBERS } from '../Settings/graphql/Queries'

const PAGE_SIZE = 10

const TicketLoadTable = () => {
  const { data, loading } = useQuery(GET_TEAM_MEMBERS)
  const [currentPage, setCurrentPage] = useState(1)
  const [members, setMembers] = useState([])
  //const [searchedColumn, setSearchedColumn] = useState('')
  //const searchInput = useRef(null)

  useEffect(() => {
    if (data?.getTeamMembers) {
      // ensure numeric values are normalized
      const normalized = data.getTeamMembers.map((m) => ({
        ...m,
        ticketLoad: Number(m.ticketLoad ?? 0),
        maxTicketLoad: Number(m.maxTicketLoad ?? 0),
      }))
      setMembers(normalized)
    }
  }, [data])

  //const handleSearch = (selectedKeys, confirm, dataIndex) => {
  //  confirm()
  //  setSearchedColumn(dataIndex)
  //}

  //const handleReset = (clearFilters) => {
  //  clearFilters()
  //}

  // decide overloaded criteria here (>= or >)
  const checkOverCap = (record) =>
    Number(record?.ticketLoad ?? 0) >= Number(record?.maxTicketLoad ?? 0)

  // helper lists for filters

  const columns = [
    {
      title: 'UserName',
      key: 'userName',
      render: (_, record) => {
        const isOverCap = checkOverCap(record)
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {record?.user?.userName || '-'}
          </span>
        )
      },
    },
    {
      title: 'Full Name (Role)',
      key: 'user',
      render: (_, record) => {
        const isOverCap = checkOverCap(record)
        const fullName = `${record.user?.firstName || ''} ${
          record.user?.lastName || ''
        }`.trim()
        const role = record.user?.role || ''
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {fullName || '-'} {role ? `(${role})` : ''}
          </span>
        )
      },
    },
    {
      title: 'Department',
      key: 'department',
      render: (_, record) => {
        const isOverCap = checkOverCap(record)
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {record.team?.department?.departmentName || '-'}
          </span>
        )
      },
    },
    {
      title: 'Team',
      key: 'team',
      render: (_, record) => {
        const isOverCap = checkOverCap(record)
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {record.team?.teamName || '-'}
          </span>
        )
      },
    },
    {
      title: 'Current Ticket Load',
      dataIndex: 'ticketLoad',
      key: 'ticketLoad',
      render: (text, record) => {
        const isOverCap = checkOverCap(record)
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {record.ticketLoad}
          </span>
        )
      },
    },
    {
      title: 'Member Load Capacity',
      dataIndex: 'maxTicketLoad',
      key: 'maxTicketLoad',
      render: (text, record) => {
        const isOverCap = checkOverCap(record)
        return (
          <span
            style={isOverCap ? { color: 'red', fontWeight: 600 } : undefined}
          >
            {record.maxTicketLoad}
          </span>
        )
      },
    },

    {
      title: 'Status',
      key: 'status',
      render: (_, record) => {
        if (checkOverCap(record)) {
          return <Tag color='red'>Overloaded</Tag>
        }
        if (!record.isAvailable) {
          return <Tag color='orange'>Unavailable</Tag>
        }
        return <Tag color='green'>Available</Tag>
      },
    },
  ]

  const paginatedData = members.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  )

  // footer component (replaces Table.Summary causing the earlier error)
  // const tableFooter = () => {
  //   const totalLoad = members.reduce(
  //     (sum, m) => sum + (Number(m.ticketLoad) || 0),
  //     0
  //   )
  //   const totalCapacity = members.reduce(
  //     (sum, m) => sum + (Number(m.maxTicketLoad) || 0),
  //     0
  //   )
  //   const utilization =
  //     totalCapacity > 0 ? ((totalLoad / totalCapacity) * 100).toFixed(1) : '0.0'
  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'space-between',
  //         padding: '10px 12px',
  //         fontWeight: 600,
  //       }}
  //     >
  //       <div>Total members: {members.length}</div>
  //       <div>
  //         Current Load: {totalLoad} &nbsp; | &nbsp; Capacity: {totalCapacity}{' '}
  //         &nbsp; | &nbsp; Utilization: {utilization}%
  //       </div>
  //     </div>
  //   )
  // }

  return (
    <div>
      <Table
        columns={columns}
        dataSource={paginatedData}
        rowKey='id'
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: PAGE_SIZE,
          total: members.length,
          onChange: setCurrentPage,
        }}
        onRow={(record) => {
          if (checkOverCap(record)) {
            return { style: { backgroundColor: '#fff1f0' } } // light red bg for overloaded
          }
          if (!record.isAvailable) {
            return { style: { backgroundColor: '#fffbe6' } } // light yellow bg for unavailable
          }
          return {}
        }}
        // footer={tableFooter}
      />
    </div>
  )
}

export default TicketLoadTable
